import { memo } from 'react';
import childPresentations from '../../constants/childPresentations';
import Default from '../../list/childPresentations/Default';
import BrickTile from '../childPresentations/BrickTile';
import LandscapeImage from '../childPresentations/LandscapeImage';
import Tile from '../childPresentations/Tile';

// Memoized because a gallery re-renders whenever its layout changes, but each tile's width is set
// on its wrapper in CarouselItems, so a tile only needs to re-render when its own props change.
const map = {
  [childPresentations.BrickTile]: {
    requiredSlots: 2,
    Component: memo(BrickTile),
  },
  [childPresentations.Tile]: {
    requiredSlots: 1,
    Component: memo(Tile),
  },
  [childPresentations.LandscapeImage]: {
    requiredSlots: 3,
    Component: memo(LandscapeImage),
  },
  [childPresentations.Cell]: {
    requiredSlots: 3,
    Component: memo(Default),
  },
};

export default function getGalleryItem(guideItem) {
  return map[guideItem?.layout] || map[childPresentations.Tile];
}
